module.exports = __webpack_public_path__ + "img/bid_img5.0e434668.jpg";